import { tns } from 'tiny-slider/src/tiny-slider';
// docs https://github.com/ganlanyuan/tiny-slider

const defaultConfig = {
  classPagination: '.slider__pagination',
  classPrevButton: '.slider__pagination__prev',
  classNextButton: '.slider__pagination__next',
  classCounter: '.slider__pagination__counter',
  classDescription: '.slider__pagination__description',
  sliderOptions: {
    items: 1,
    gutter: 20,
    slideBy: 1,
    mouseDrag: true,
  },
};

function prefixZero(number, decimals = 2) {
  if (decimals <= 0) return number;
  const numberLength = number.toString().length;
  const zeros = new Array(decimals + 1 - numberLength).join('0');
  return `${zeros}${number}`;
}

function createSelector(...arrayItems) {
  return [...arrayItems].join(' ');
}

export default class Slider {
  constructor(element, config) {
    this.element = element;
    this.config = { ...defaultConfig, ...config };

    const staticSliderOptions = JSON.parse(this.element.dataset.sliderOptions);

    const selectors = {
      prevButton: createSelector(
        this.config.classPagination,
        this.config.classPrevButton
      ),
      nextButton: createSelector(
        this.config.classPagination,
        this.config.classNextButton
      ),
      counter: createSelector(
        this.config.classPagination,
        this.config.classCounter
      ),
      description: createSelector(
        this.config.classPagination,
        this.config.classDescription
      ),
    };

    this.parent = this.element.parentNode;
    this.buttons = {
      prev: this.parent.querySelector(selectors.prevButton),
      next: this.parent.querySelector(selectors.nextButton),
    };

    this.config.sliderOptions = {
      ...defaultConfig.sliderOptions,
      prevButton: this.buttons.prev,
      nextButton: this.buttons.next,
      ...staticSliderOptions,
    };
    this.slider = null;
    this.counter = this.parent.querySelector(selectors.counter);
    this.description = this.parent.querySelector(selectors.description);
    this.pagination = this.parent.querySelector(this.config.classPagination);

    this.init();

    return this;
  }

  init() {
    this.slider = tns({
      container: this.element,
      ...this.config.sliderOptions,
    });

    if (this.counter) {
      this.changeCounter(this.slider.getInfo());

      this.slider.events.on('transitionEnd', info => {
        this.changeCounter(info);
      });
    }
    if (this.description) {
      this.changeDescription(this.slider.getInfo());

      this.slider.events.on('transitionEnd', info => {
        this.changeDescription(info);
      });
    }

    setTimeout(() => {
      this.positionPagination();
    }, 400);

    window.addEventListener('resize', () => {
      this.positionPagination();
    });

    this.slider.events.on('transitionEnd', this.positionPagination.bind(this));
  }

  positionPagination() {
    if (
      this.pagination &&
      this.pagination.classList.contains('slider__pagination--cards')
    ) {
      const img = this.parent.querySelector('.tns-slide-active picture img');
      if (img) {
        this.pagination.style.bottom =
          this.parent.clientHeight - img.clientHeight - 1;
      }
      if (!this.pagination.classList.contains('positioned')) {
        this.pagination.classList.add('positioned');
      }
    }
  }

  changeCounter(info) {
    const actual = info.displayIndex;
    const max = info.slideCount;
    this.counter.innerHTML = `${prefixZero(actual)} / ${prefixZero(max)}`;
  }

  changeDescription(info) {
    const item = info.slideItems[info.index];
    const dataItem = item.hasAttribute('data-description')
      ? item
      : item.querySelector('[data-description]');
    if (dataItem) {
      this.description.innerHTML = dataItem.dataset.description || '';
    }
  }

  update() {
    this.slider.destroy();
    this.slider.init();
  }

  destroy() {
    this.slider.destroy();
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider/Slider.static.js